import r from "react";
import e from "../icon/src/Error.esm.js";
const c = {
  errorIcon: {
    icon: /* @__PURE__ */ r.createElement(e, null),
    color: "var(--color-universal-redMid)",
    className: "fuse-checkbox__error-icon",
    dataTestId: "fuse-checkbox__error-icon",
    size: "small"
  },
  errorText: {
    color: "var(--color-universal-redMid)",
    className: "fuse-checkbox__error-text",
    dataTestId: "fuse-checkbox__error-text",
    size: "m1",
    tag: "span",
    type: "paragraph"
  }
};
export {
  c as default
};
